import { create } from 'zustand';

import type { RemoteConfigAdapter } from '@/adapters/remoteConfig/types';

export interface RemoteConfigAdapters {
  remoteConfig: RemoteConfigAdapter;
}

interface RemoteConfigState {
  isReady: boolean;
  isAgentHandoffEnabled: boolean;
}

interface RemoteConfigActions {
  initialize: () => Promise<void>;
  subscribeToUpdates: () => () => void;
}

const AGENT_HANDOFF_KEY = 'agent_handoff';

export const createRemoteConfigStore = (adapters: RemoteConfigAdapters) =>
  create<RemoteConfigState & RemoteConfigActions>((set) => {
    const readFlags = async () => {
      const isAgentHandoffEnabled = await adapters.remoteConfig.getBoolean(AGENT_HANDOFF_KEY);
      set({ isAgentHandoffEnabled });
    };

    return {
      isReady: false,
      isAgentHandoffEnabled: false,

      initialize: async () => {
        await adapters.remoteConfig.fetchAndActivate();
        await readFlags();
        set({ isReady: true });
      },

      subscribeToUpdates: () =>
        adapters.remoteConfig.onConfigUpdate(() => {
          void readFlags();
        }),
    };
  });
